import { render, staticRenderFns } from "./BDXEditFormBDXStatus.vue?vue&type=template&id=15b920e2"
import script from "./BDXEditFormBDXStatus.vue?vue&type=script&lang=js"
export * from "./BDXEditFormBDXStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports